// @flow
import React from 'react';
import { connect } from 'react-redux';

import { BannerMessages } from '../TemporalBanner';
import * as selectors from '../../reducers';
import * as fromTemporaryEvents from '../../reducers/temporaryEvents';

export const GROUP_NETWORK_BANNERS = 'networkBanners';


export default connect(
  state => {
    const events = selectors.getTemporaryEventsByGroup(state, GROUP_NETWORK_BANNERS);
    return {
      event: events.filter(
        event => fromTemporaryEvents.isActive(event)
      )[0],
    };
  },
)(BannerMessages);



// WEBPACK FOOTER //
// ./src/scripts/components/NetworkBanner/index.jsx